"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemSelected = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MenuItemSelected = styled_components_1.default.div `
  position: absolute;

  top: 8px;
  left: 8px;

  width: 5px;
  height: 5px;

  border-radius: 50%;

  background-image: radial-gradient(circle at right top, #fff 0%, #000 60%);
`;
//# sourceMappingURL=menu-item-selected.js.map